import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class EmploymentDetailsService {

	constructor(public http: HttpClient) { }
	public getPucaFormDetails(): Observable<any> {
		return this.http.get(environment.BASE_URL_PUCA + 'das/getInitFormData')
	}

	public saveApplicationData(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PUCA + 'das/saveApplicationData', payload)
	}
}
